import { languages } from './language'

const SITE_URL = 'https://www.urkla.com'

const siteLanguage = (language?: string): string => {
  const code = (language || '').slice(0, 2).toLowerCase()
  return languages.some((l) => l.code === code) ? code : 'en'
}

export const legalLinks = (language?: string) => {
  const lang = siteLanguage(language)
  return {
    terms: `${SITE_URL}/${lang}/terms`,
    privacy: `${SITE_URL}/${lang}/privacy`,
  }
}
